const salutationOptions: string[] = ["Mr.", "Master.", "Miss.", "Mrs.", "Dr."]
const genderOptions: string[] = ["Male", "Female", "Other"]
const languageOptions: string[] = [
  "English",
  "Hindi",
  "Marathi",
  "Gujarati",
  "Bangla",
  "Dogri",
  "Konkani",
  "Maithili",
  "Nepali",
  "Oriya",
  "Punjabi",
  "Sanskrit",
  "Sindhi",
  "Urdu",
]
const bloodOptions: string[] = [
  "A+",
  "A-",
  "B+",
  "B-",
  "O+",
  "O-",
  "AB+",
  "AB-",
]
const categoryOptions: string[] = [
  "SELF_PAYING",
  "INSURANCE_TPA",
  "TRUST",
  "CORPORATE",
  "CGHS",
  "PSU",
  "CLINICAL_RESEARCH",
  "GOVERNMENT_SCHEMES"
]
const insuranceOptions: string[] = [
  "United Health Care Parekh InsuranceTPA Private Limited",
  "Medi Assist Insurance TPA Private Limited",
  "MD India Health Insurance TPA Private Limited",
  "Paramount Health Services & Insurance TPA Private Limited",
  " Heritage Health Insurance TPA Private Limited",
  "Family Health Plan Insurance TPA Limited",
  "Raksha Health Insurance TPA Private Limited",
  " Vidal Health Insurance TPA Private Limited",
  "Anyuta Insuance TPA In Health Care Private Limited",
  "East West Assist Insurance TPA Private Limited",
  "Medsave Health Insurance TPA Limited",
  "Genins India Insurance TPA Limited",
  "Alankit Insurance TPA Limited",
  "Health India Insurance TPA Services Private Limited",
  "Good Health Insurance TPA Limited",
  "Vipul Medcorp Insurance TPA Private Limited",
  "Park Mediclaim Insurance TPA Private Limited",
  "Safeway Insurance TPA Private Limited",
  "Anmol Medicare Insurance TPA Limited",
  "Grand Insurance TPA Private Limited",
  "Rothshield Insurance TPA Limited",
  "Ericson Insurance TPA Private Limited",
  "Health Insurance TPA of India Limited",
  "Vision Digital Insurance TPA Private Limited",
  "Happy Insurance TPA Services Pvt.Ltd",
]
const cityOptions: string[] = [
  "Thane",
  "Pune",
  "Mumbai",
  "Vile Parle",
  "Ghatkopar",
  "Borivali",
  "Sion",
  "Nashik",
  "Malad",
  "Mulund",
  "Kemps Corner",
  "Panvel",
  "Kolhapur",
  "Indore",
]


const psuOptions: string[] = [
  "Naval",
  "RCF",
  "Central Railway",
  "MINT",
  // "Others"
]


const cghsOption: string[] = [
  "Servicer",
  "Pensioner"

]

const trustOptions: string[] = [
  "MOCF"
]

const stateOptionsValues: any = {
  Maharastra: ["Mumbai", "Pune", "Nagpur", "Amravati"],
  MadhyaPradesh: ["Indore", "Bhopal", "Jabalpur"],
}

const stateOptions = ["Maharastra", "Madhya Pradesh"]

const countryOptions: string[] = ['Afghanistan', 'Åland Islands', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bangladesh', 'Barbados', 'Bahamas', 'Bahrain', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'British Indian Ocean Territory', 'British Virgin Islands', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burma', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo-Brazzaville', 'Congo-Kinshasa', 'Cook Islands', 'Costa Rica', 'Croatia', 'Curaçao', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'East Timor', 'Ecuador', 'El Salvador', 'Egypt', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands', 'Faroe Islands', 'Federated States of Micronesia', 'Fiji', 'Finland', 'France', 'French Guiana', 'French Polynesia', 'French Southern Lands', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Heard and McDonald Islands', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern Mariana Islands', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn Islands', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Réunion', 'Romania', 'Russia', 'Rwanda', 'Saint Barthélemy', 'Saint Helena', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Martin', 'Saint Pierre and Miquelon', 'Saint Vincent', 'Samoa', 'San Marino', 'São Tomé and Príncipe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Sint Maarten', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia', 'South Korea', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard and Jan Mayen', 'Sweden', 'Swaziland', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Togo', 'Tokelau', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks and Caicos Islands', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Vietnam', 'Venezuela', 'Wallis and Futuna', 'Western Sahara', 'Yemen', 'Zambia', 'Zimbabwe']
const referredOptions: string[] = ["Organisation 1", "Organisation 2"]
const healthInsuranceOptions: string[] = ["Yes", "No", "Not Known"]
const tpaOptions: string[] = [
  "United Health Care Parekh InsuranceTPA Private Limited",
  "Medi Assist Insurance TPA Private Limited",
  "MD India Health Insurance TPA Private Limited",
  "Paramount Health Services & Insurance TPA Private Limited",
  "Heritage Health Insurance TPA Private Limited",
  "Family Health Plan Insurance TPA Limited",
  "Raksha Health Insurance TPA Private Limited",
  "Vidal Health Insurance TPA Private Limited",
  "Anyuta Insuance TPA In Health Care Private Limited",
  "East West Assist Insurance TPA Private Limited",
  "Medsave Health Insurance TPA Limited",
  "Genins India Insurance TPA Limited",
  "Alankit Insurance TPA Limited",
  "Health India Insurance TPA Services Private Limited",
  "Good Health Insurance TPA Limited",
  "Vipul Medcorp Insurance TPA Private Limited",
  "Park Mediclaim Insurance TPA Private Limited",
  "Safeway Insurance TPA Private Limited",
  "Anmol Medicare Insurance TPA Limited",
  "Grand Insurance TPA Private Limited",
  "Rothshield Insurance TPA Limited",
  "Ericson Insurance TPA Private Limited",
  "Health Insurance TPA of India Limited",
  "Vision Digital Insurance TPA Private Limited",
  "Happy Insurance TPA Services Pvt. Ltd",
]

const ethnicityOptions: string[] = [
  "Asian",
  "African",
  "Caucasian",
  "Hispanic",
  "American",
  "Pacific Islander",
  "Mixed race",
]

// const patientTag: string[] = [
//   "VIP",
//   "Transfer",
//   "Special Needs"
// ]
const patientTag = {
  tags: [
    "VIP",
    "Transfer",
    "Special Needs"
  ]
}
const maritalStatusOptions: string[] = [
  "Single",
  "Married",
  "Widowed",
  "Divorced",
]
const educationLevelOptions: string[] = [
  "Uneducated",
  "Primary",
  "Secondary",
  "Metric",
  "12th",
  "Bachelors",
  "Masters",
  "PhD",
]
const socioEconomicOptions: string[] = ["Low", "Med", "High"]
const occupationOptions: string[] = [
  "Not Working",
  "Retired",
  "Service",
  "Business",
]

const HealthInsuranceOptions = {
  condition: ["Yes", "No", "Not known"],
  options: [
    "United Health Care Parekh InsuranceTPA Private Limited",
    "Medi Assist Insurance TPA Private Limited",
    "MD India Health Insurance TPA Private Limited",
    "Paramount Health Services & Insurance TPA Private Limited",
    "Heritage Health Insurance TPA Private Limited",
    "Family Health Plan Insurance TPA Limited",
    "Raksha Health Insurance TPA Private Limited",
    "Vidal Health Insurance TPA Private Limited",
    "Anyuta Insuance TPA In Health Care Private Limited",
    "East West Assist Insurance TPA Private Limited",
    "Medsave Health Insurance TPA Limited",
    "Genins India Insurance TPA Limited",
    "Alankit Insurance TPA Limited",
    "Health India Insurance TPA Services Private Limited",
    "Good Health Insurance TPA Limited",
    "Vipul Medcorp Insurance TPA Private Limited",
    "Park Mediclaim Insurance TPA Private Limited",
    "Safeway Insurance TPA Private Limited",
    "Anmol Medicare Insurance TPA Limited",
    "Grand Insurance TPA Private Limited",
    "Rothshield Insurance TPA Limited",
    "Ericson Insurance TPA Private Limited",
    "Health Insurance TPA of India Limited",
    "Vision Digital Insurance TPA Private Limited",
    "Happy Insurance TPA Services Pvt. Ltd",
  ],
}

const cghsOptions = {
  condition: ["Yes", "No", "Not known"],
  options: [
    "Star",
    "HDFC",
    "Bajaj",
    "ICICI",
    "Manipal Cigna",
    "Aditya Birla",
    "SBI",
    "Care",
    "Reliance",
    "Religare",
  ],
}

const govSchemeOptions = {
  condition: ["Yes", "No", "Not known"],
  options: [
    "Naval",
    "RCF",
    "Central Railway",
    "MINT",
    "GIPSA",
    "New India",
    "United",
    "National Insurance",
    "Oriental Insurance",
  ],
}

const websitesOptions: string[] = [
  "Google",
  "www.mocindia.com",
  "www.practo.com",
  // "www.sehat.com",
  // "Media",
  "Others",
]

const referredByOptions: string[] = [
  "Self",
  "PRO /Marketing",
  "Doctor",
  "Others",
  "Social Media"
]

export {
  salutationOptions,
  occupationOptions,
  socioEconomicOptions,
  educationLevelOptions,
  maritalStatusOptions,
  ethnicityOptions,
  cghsOptions,
  stateOptions,
  countryOptions,
  referredOptions,
  HealthInsuranceOptions,
  tpaOptions,
  genderOptions,
  languageOptions,
  bloodOptions,
  categoryOptions,
  cityOptions,
  govSchemeOptions,
  stateOptionsValues,
  websitesOptions,
  referredByOptions,
  psuOptions,
  cghsOption,
  trustOptions,
  insuranceOptions,
  patientTag
}
